import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

const VulnerableAppNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="vulnerableapp" />;
};

export default VulnerableAppNode;
